// @flow

import React from 'react';
import classNames from 'classnames';

export type JobPresenterUser = {
  name: string,
  avatarUrl: string
};

type User = {
  +name: ?string,
  +avatar: {
    +url: string
  }
};

type Props = {
  +user: User,
  className?: string,
  style?: Object
};

export default class UserAvatar extends React.PureComponent<Props> {
  // I'm so sorry, please delete this method as soon as you can
  static convertUserFromJobPresenter({ name, avatarUrl }: JobPresenterUser): User {
    return {
      name,
      avatar: {
        url: avatarUrl
      }
    };
  }

  render() {
    return (
      <img
        src={this.props.user.avatar.url}
        className={classNames("circle border border-gray bg-white", this.props.className)}
        alt={this.props.user.name}
        title={this.props.user.name}
        style={this.props.style}
      />
    );
  }
}
